import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WarningIcon from 'src/components/LoaderImg/Avatar.svg';

type Props = {
  close: any;
  handleDelete: any;
  selectedFacility: any;
};

const ClockInFacilityModal = (props: Props) => {
  const { close, handleDelete, selectedFacility } = props;
  const getAssignedFacilities = useSelector((state: any) => state.getFacilityDropDownReducer);
  const getFacilityUuid = localStorage.getItem('facilityId') || '';
  const isFacilitySwitch = useSelector((state: any) => state.updateFacilityDropDownReducer);
  const checkoutResponse = useSelector((state: any) => state.checkoutReducer);
  const [currentFacility, setCurrentFacility] = useState<any>('');

  useEffect(() => {
    const facility = getAssignedFacilities.response?.data?.data?.find((fac: any) => {
      if (fac?.uuid === getFacilityUuid) {
        return fac;
      }
    });
    setCurrentFacility(facility);
  }, [getAssignedFacilities]);

  return (
    <Box p={3}>
      <>
        <DialogContent sx={{padding:'6px !important'}}>
          <Box sx={{ display: 'flex' }}>
            <Box
              sx={{ height: '50px' }}
              p={1}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  marginRight: '12px',
                }}
              >
                <img
                  alt=""
                  src={WarningIcon}
                />
              </div>
            </Box>
            <Box sx={{marginTop:'6px'}}>
              <Typography variant="h5">Would you like to clock out?</Typography>
              <Typography
                sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                variant="body2"
                mt={1}
              >
                 You are about to leave{' '}
                <span style={{ fontWeight: 'bold', color: '#000' }}> {currentFacility?.name} </span>{' '}
                facility. Would you like to clock out?
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{marginTop:'12px'}}>
          <Button
            autoFocus
            sx={{ color: '#111927' }}
            onClick={close}
          >
            Leave and remain clocked-in
          </Button>
          <Button
            autoFocus
            variant="contained"
            sx={{
              background: '#F04438',
              color: '#fff',
              '&:hover': {
                background: '#F04438',
              },
            }}
            onClick={handleDelete}
            disabled={isFacilitySwitch.loading || checkoutResponse?.loading}
          >
          Leave and clock out
          </Button>
        </DialogActions>
      </>
    </Box>
  );
};

export default ClockInFacilityModal;
